import { Dispatch, SetStateAction } from 'react';

import { format } from 'date-fns';
import { DateRange } from 'react-day-picker';

import { Button } from '@/new/components/shadcn/button';
import { Calendar } from '@/new/components/shadcn/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/new/components/shadcn/popover';

export function DateRangePicker({
  dateRange,
  setDateRange,
}: {
  dateRange: DateRange;
  setDateRange: Dispatch<SetStateAction<DateRange>>;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button data-empty={!dateRange} className="justify-start text-left font-normal data-[empty=true]:text-gray-400">
          <span className="iconify lucide--calendar-range"></span>
          <span>{dateRange.from && format(dateRange.from, 'PPP')}</span>
          <span>{dateRange.to && format(dateRange.to, 'PPP')}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="max-w-none bg-white p-1">
        <Calendar
          mode="range"
          selected={dateRange}
          onSelect={setDateRange}
          buttonVariant="default"
          numberOfMonths={2}
          required
        />
      </PopoverContent>
    </Popover>
  );
}
